// ParameterTabs.js
import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Button, Card, Form } from 'react-bootstrap';
import ParameterCard from '../ParameterCard/ParameterCard'
import { DataPullerService } from '../../Services/DataPullerService';
import './ParameterTabs.css';

const ParameterTabs = ({ parameterGroups, selectedValues, setSelectedValues, onSave, activeKey, handleTabSelect, handleValueChange, parameterOptions }) => {

    const [useTimeCard, setUseTimeCard] = useState(false);

    const handleToggleTimeCard = () => {
        setUseTimeCard(prev => !prev);
    };
    
    return (
        <div className='parameter-tabs d-flex flex-column flex-grow-1'>
            <Tabs
                id="parameter-tabs"
                activeKey={activeKey}
                onSelect={handleTabSelect}
                className="main-tabs"
                justify
            >
                {parameterGroups.map((group, ix) => (
                    <Tab eventKey={ix} title={group.name.toUpperCase()} key={group.id} tabClassName='param-tab'>
                        <div className='parameter-cards h-100 overflow-y-auto flex-grow-1 d-flex justify-content-around flex-wrap w-100'>
                        {group.name.toUpperCase() === 'TIME' ? (
                                <>
                                    <div className="w-100 d-flex justify-content-end mb-3">
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={useTimeCard}
                                                onChange={handleToggleTimeCard}
                                            />{' '}
                                            Use Advanced Time Selection
                                        </label>
                                    </div>
                                    {useTimeCard ? (
                                        <TimeParameterCard />
                                    ) : (
                                        group.parameters.map(param => (
                                            <ParameterCard
                                                key={param.id}
                                                parameter={param}
                                                selectedValues={selectedValues}
                                                setSelectedValues={handleValueChange}
                                                values={parameterOptions[param.id] || []}
                                            />
                                        ))
                                    )}
                                </>
                            ) : (
                                group.parameters.map(param => (
                                    <ParameterCard
                                        key={param.id}
                                        parameter={param}
                                        selectedValues={selectedValues}
                                        setSelectedValues={handleValueChange}
                                        values={parameterOptions[param.id] || []}
                                    />
                                ))
                            )}
                        </div>
                    </Tab>
                ))}
            </Tabs>
        </div>
    );
};

const TimeParameterCard = () => {
    const [filter, setFilter] = useState('');
    const timeOptions = [
        'Today',
        'Yesterday',
        'Last Week',
        'Last Month',
        'Last Year',
        'Current Week',
        'Current Month',
        'Current Year'
    ];

    const filteredValues = timeOptions.filter(option => 
        option.toLowerCase().includes(filter.toLowerCase())
    );

    return (
        <Card className="mb-3 parameter-card">
            <Card.Body className=''>
                <Card.Title className='text-left text-info'>Advanced time selection</Card.Title>
                <Form.Control 
                    type="text" 
                    placeholder="Start typing to filter values" 
                    value={filter} 
                    onChange={(e) => setFilter(e.target.value)} 
                    size='sm'
                    className='mt-2'
                />
                <div className="values-list p-2 mt-3">
                    {filteredValues.map((option, index) => (
                        <Form.Check 
                            key={index} 
                            type="checkbox" 
                            label={option}
                        />
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

export default ParameterTabs;
